module.exports = __webpack_public_path__ + "4e7bbdf65231c5f23aeacf085226ed15.svg";